import { render } from "./CheckoutComentar.vue?vue&type=template&id=7ba07727"
import script from "./CheckoutComentar.vue?vue&type=script&lang=js"
export * from "./CheckoutComentar.vue?vue&type=script&lang=js"

import "./CheckoutComentar.vue?vue&type=style&index=0&id=7ba07727&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__